import React, { useEffect, useState } from "react";
import { BsFileArrowUp } from "react-icons/bs";

export default function ScrollToTop() {
    const [isVisible, setIsVisible] = useState(false);

    // Show button when page is scorlled upto given distance
    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Set the top cordinate to 0
    // make scrolling smooth
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);
    }, []);

    return (
        <div className="scroll-to-top relative w-full mt-[14em] items-center">
            {isVisible &&
                <div onClick={scrollToTop} className="text-[3rem] opacity-60 hover:opacity-100 absolute right-[.6em] md:right-[2.3em] bottom-0 hover:scale-110 transition-all">
                    <BsFileArrowUp />
                </div>}
        </div>
    );
}